export default __webpack_public_path__ + "static/media/WebTechnologies_Dashboard.8567c1f7.svg";